// extracted by mini-css-extract-plugin
export var active = "_l2-e";
export var blink = "_l2-f";
export var dropDownSelector = "_l2-5";
export var dropDownWrapper = "_l2-4";
export var fakeCursor = "_l2-d";
export var fontSizeButton = "_l2-7";
export var formQuillEditor = "_l2-0";
export var pressed = "_l2-g";
export var qlBlank = "_l2-1";
export var textFormattingToolbar = "_l2-2";
export var textFormattingToolbarClosed = "_l2-3";
export var textFormattingToolbarInline = "_l2-6";
export var textToolbarOption = "_l2-8";
export var toolbarCell = "_l2-a";
export var toolbarCellCollapsed = "_l2-b";
export var toolbarOptionHitArea = "_l2-c";
export var toolbarOverflow = "_l2-9";